// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".error-page .error-code[data-v-437032b8]{font-size:5rem}.error-page h1[data-v-437032b8]{font-size:2rem}.error-page h2[data-v-437032b8]{font-size:1.5rem}.error-page p[data-v-437032b8]{font-size:1.25rem}", ""]);
// Exports
module.exports = exports;
